module.exports = __webpack_public_path__ + "static/img/titleImg2.7871d86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/titleImg2.png
// module id = 6oPP
// module chunks = 0